"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationKey = void 0;
/* istanbul ignore file @preserve */
/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
let TranslationKey = exports.TranslationKey = /*#__PURE__*/function (TranslationKey) {
  TranslationKey["chooseAnOption"] = "chooseAnOption";
  TranslationKey["email"] = "email";
  TranslationKey["enterTelephoneNumber"] = "enterTelephoneNumber";
  TranslationKey["enterYourEmail"] = "enterYourEmail";
  TranslationKey["invalidEmail"] = "invalidEmail";
  TranslationKey["invalidTelephoneNumber"] = "invalidTelephoneNumber";
  TranslationKey["notifyMe"] = "notifyMe";
  TranslationKey["notifyMeSuccess"] = "notifyMeSuccess";
  TranslationKey["pleaseTryAgainLater"] = "pleaseTryAgainLater";
  TranslationKey["requestFailed"] = "requestFailed";
  TranslationKey["sms"] = "sms";
  TranslationKey["submitNotification"] = "submitNotification";
  TranslationKey["thankYou"] = "thankYou";
  return TranslationKey;
}({});
